import {QueryClient, QueryClientProvider} from '@tanstack/react-query';
import type {PropsWithChildren} from 'react';
import styles from './layout.module.css';
import {PublicResponsiveLayout} from '@/components/utils/public-responsive-layout';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
    },
  },
});

type Props = PropsWithChildren;

export function Layout({children}: Props) {
  return (
    <QueryClientProvider client={queryClient}>
      <PublicResponsiveLayout>
        <div className={styles.global}>{children}</div>
      </PublicResponsiveLayout>
    </QueryClientProvider>
  );
}
